/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import {Table , Row , Col} from 'react-bootstrap';
import CDNImage from '../../../media/image.js';
import CDNAudio from '../../../../classes/audio.js';
class VocabPanel extends React.Component {


    constructor(props){
        super();
        this.state = {
            assignment:props.data.assignment
        }

    }

    componentWillReceiveProps(props){
        this.setState({assignment:props.data.assignment})
    }

    handelAudioClick(src){
        (new CDNAudio(src)).play();
    }

    renderRow(){
        var items = [];

        for(var idx = 0; idx < this.state.assignment.vocab.length; idx++){

            let imageCol =    <td width={110}><CDNImage size={90} isVocab src={this.state.assignment.vocab[idx].picture}></CDNImage></td>
            if(sessionStorage.getItem("product") == "huber" || sessionStorage.getItem('product') == "larousse")
            {
                imageCol = "";
            }

            items.push(<tr>
                {imageCol}
                <td>

                    {this.state.assignment.vocab[idx].translation}
                </td>
                <td className="p-0" width={90}>
                    <center className="p-5">
                        <button onClick={this.handelAudioClick.bind(this ,  this.state.assignment.vocab[idx].audio)} type="button" className="palette-White-Disabled bg m-r-30 small btn btn-icon command-edit waves-effect waves-circle" data-row-id="10248">
                            <CDNImage className="m-b-5" size={15} src="img/audioWordPod.png"/>
                        </button>
                    </center>
                </td>

            </tr>)
        }

        return items;
    }

    render(){

        if(!this.state.assignment) return null;

        return (
            <div>
                <div className="pmb-block">
                    <div className="pmbb-body">
                        <Table condensed striped responsive bordered>
                            <tbody>
                                {this.renderRow()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-232' } defaultMessage={ 'Vocab' }/>,
    component: VocabPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/assignment/vocabulary-panel.js